/* tslint:disable */
/* eslint-disable */
/**
 * KNMI exons API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface ParametersGeoBoundingBox
 */
export interface ParametersGeoBoundingBox {
    /**
     * 
     * @type {string}
     * @memberof ParametersGeoBoundingBox
     */
    'type': ParametersGeoBoundingBoxTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof ParametersGeoBoundingBox
     */
    'north_latitude': number;
    /**
     * 
     * @type {number}
     * @memberof ParametersGeoBoundingBox
     */
    'south_latitude': number;
    /**
     * 
     * @type {number}
     * @memberof ParametersGeoBoundingBox
     */
    'east_longitude': number;
    /**
     * 
     * @type {number}
     * @memberof ParametersGeoBoundingBox
     */
    'west_longitude': number;
}

export const ParametersGeoBoundingBoxTypeEnum = {
    BoundingBox: 'BoundingBox'
} as const;

export type ParametersGeoBoundingBoxTypeEnum = typeof ParametersGeoBoundingBoxTypeEnum[keyof typeof ParametersGeoBoundingBoxTypeEnum];


